<div class="icon-wrapper">
  <span class="icon-warning--alt--filled text-danger me-2"></span>
  <span class="icon-currency--dollar" [ngClass]="{'price--line-through': (offense?.penaltyState == penaltyStateCancelled)}" *ngIf="offense?.penaltyIssued"></span>
</div>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label for="offense" class="control-label">{{'i18n.domain.parker-registration.fields.offense' | translate}}</label>
    <div class="tooltip-finetune">
      <ejs-tooltip content="{{offense?.offenseLog}}">
        <div>{{getOffenseType(offense) | translate}}</div>
      </ejs-tooltip>
    </div>
  </div>
  <div class="form-group col-md-6" *ngIf="displayIssuerName">
    <label for="issuer" class="control-label">{{'i18n.domain.parker-registration.fields.issuer' | translate}}</label>
    <div>{{getRegisteredByText(offense)}}</div>
  </div>
</div>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label for="penaltyNumber" class="control-label">{{'i18n.domain.parker-registration.fields.penaltyNumber' | translate}}</label>
    <div>{{offense?.penaltyNumber}}</div>
  </div>
  <div class="form-group col-md-6">
    <label for="penaltyParkingNumber" class="control-label">{{'i18n.domain.parker-registration.fields.penaltyParkingNumber' | translate}}</label>
    <div>{{offense?.penaltyParkingNumber}}</div>
  </div>
</div>

<div class="d-flex align-items-center flex-wrap" *ngIf="offense.mediaFiles?.length">
  <app-async-image *ngFor="let imageId of offense.mediaFiles" [request]="getImageRequest(offense.id, imageId)"></app-async-image>
</div>
